import { AnimatePresence, motion } from "framer-motion";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { Pencil } from "lucide-react";
import { useDispatch, useSelector } from "react-redux"
import { editStatusPropsect } from "../../slices/formularioSlice";

export default function ModalViewProspect({ isModalOpen, setIsModalOpen, prospect, setIsModalEdit, handleEditStatus }) {

  
  const {  loading, error } = useSelector((state) => state.formulario);

  const handleModalEdit = () => {
    setIsModalOpen(false)
    setIsModalEdit(true)
  }
  
  

  

  return (
    <AnimatePresence>
      {isModalOpen && (
        <motion.div
          key="modal-background"
          onClick={() => setIsModalOpen(false)}
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-20"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
        >
          <motion.div
            key="modal-content"
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="bg-background rounded-lg shadow-lg p-6 font-poppina w-[500px] mx-4 border border-gray-100"
          >
           
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-xl font-semibold text-text">
                Información del Prospecto
              </h3>

              <div className="flex items-center" >
              <button onClick={() => handleModalEdit()  } >
                <Pencil className="w-5 h-5 text-gray-400 hover:text-gray-500 " />
              </button>

              <button
                onClick={() => setIsModalOpen(false)}
                className="text-gray-400 hover:text-gray-600 transition-colors ml-4 "
              >
                <XMarkIcon className="w-6 h-6" />
              </button>
              </div>
            </div>

           
            <div className="space-y-4">
              <div className="flex justify-between">
                <span className="font-medium text-text">Nombre:</span>
              <span className="text-text " style={{ maxWidth: '200px', wordWrap: 'break-word', whiteSpace: 'normal' }} >{prospect.name || "Desconocido"}</span>
              </div>

              <div className="flex justify-between">
                <span className="font-medium text-text">Email:</span>
                <span className="text-text">{prospect.email || "N/A"}</span>
              </div>

              <div className="flex justify-between">
                <span className="font-medium text-text">Teléfono:</span>
                <span className="text-text">{"+" + prospect.phone}</span>
              </div>

              <div className="flex justify-between">
                <span className="font-medium text-text">Descripción:</span>
                <span className="text-text text-right">
                  {prospect.description || "Sin descripción"}
                </span>
              </div>

              <div className="flex justify-between">
                <span className="font-medium text-text">Nueva Idea:</span>
                <span className="text-text">{prospect.newIdea ? "Sí" : "No"}</span>
              </div>

              <div className="flex justify-between">
                <span className="font-medium text-text">Podcast:</span>
                <span className="text-text">{prospect.namePodcast || "Sin podcast"}</span>
              </div>
            </div>

            
            <div className="mt-6 flex justify-end">
              <button
                onClick={() => handleEditStatus(prospect._id, "Rejected")}
                className="px-4 py-2 text-red-500 rounded-lg border border-red-300 bg-red-100 transition-colors mr-4"
              >
                {loading ? "Cargando..." : "Rechazar" }
              </button>
              <button
                onClick={() => handleEditStatus(prospect._id, "Approved")}
                className="px-4 py-2 text-green-500 rounded-lg border border-green-300 bg-green-100 transition-colors"
              >
                {loading ? "Cargando..." : "Aceptar" }
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}